import type React from 'react';

import type { ApiProduct } from '../../../../../models/ecommerce/product/ApiProduct';
import type { LoopSearchProductResults } from '../../../../search/models/models';

import BuyableSearchProduct from '../../../../common/components/molecules/BuyableSearchProduct';
import { SearchResultAbsoluteLink } from '../../../../search/components/GlobalSearchResultPage/SearchResultLink';
import { SearchResultType } from '../../../../search/models/SearchResultType';
import NoticeRibbonDefaultStore from '../../NoticeRibbonDefaultStore';
import SearchOverlayResultList from '../SearchOverlay/SearchOverlayResultList';

export interface CheckoutSearchOveralyResultContentProps {
    onFullResultClick: () => void;
    onItemAddToCartClick: (item: ApiProduct, index: number) => void;
    onItemRemoveFromCartClick: (item: ApiProduct, index: number) => void;
    result: LoopSearchProductResults;
    queryUsed?: string;
    query?: string;
}

const CheckoutOverlayResultContent = (
    props: React.PropsWithChildren<CheckoutSearchOveralyResultContentProps>,
) => {
    return (
        <>
            <NoticeRibbonDefaultStore />
            <SearchOverlayResultList
                items={props.result.items}
                renderItem={(item: ApiProduct, index: number) => (
                    <BuyableSearchProduct
                        analyticsOptions={{
                            list: 'Checkout - sök - drop down',
                            listPosition: 0,
                            position: index,
                        }}
                        silent={false}
                        product={item}
                        isALink={false}
                        isAsyncLink={false}
                        onAddToCartClick={() => props.onItemAddToCartClick(item, index)}
                        onRemoveFromCartClick={() => props.onItemRemoveFromCartClick(item, index)}
                    />
                )}
            />
            <div className="u-paddingVmd u-paddingHmd u-borderBottom u-textCenter">
                <p className="u-marginVz">
                    <SearchResultAbsoluteLink
                        resultType={SearchResultType.Products}
                        searchTerm={props.queryUsed}
                        originalSearchTerm={
                            props.queryUsed !== props.query ? props.query : undefined
                        }
                        onPress={props.onFullResultClick}
                        aria-label={`visa alla ${props.result.totalResults} träffar på ${props.queryUsed}`}
                    >
                        Visa alla {props.result.totalResults} träffar på &quot;{props.queryUsed}
                        &quot;
                    </SearchResultAbsoluteLink>
                </p>
            </div>
        </>
    );
};

export default CheckoutOverlayResultContent;
